import { Database, FlaskConical, PenLine, Radio, School } from "lucide-react";
import { SOURCE_LABELS, fmtDate } from "@/constants/sports";

const STYLES = {
  fanflare: ["bg-blue-500/10 text-blue-400 border-blue-500/30", Radio],
  testing_app: ["bg-emerald-500/10 text-emerald-400 border-emerald-500/30", FlaskConical],
  manual: ["bg-amber-500/10 text-amber-400 border-amber-500/30", PenLine],
  sample: ["bg-slate-500/10 text-slate-400 border-slate-500/30", Database],
  school_roster: ["bg-teal-500/10 text-teal-300 border-teal-500/30", School],
};

export const SourceBadge = ({ source, updatedAt, testId }) => {
  const [cls, Icon] = STYLES[source] || STYLES.manual;
  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-2">
      <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-data text-[11px] uppercase tracking-wider ${cls}`}>
        <Icon className="h-3 w-3" />
        {SOURCE_LABELS[source] || source}
      </span>
      {updatedAt && <span className="font-data text-[11px] text-slate-500">Updated {fmtDate(updatedAt)}</span>}
    </div>
  );
};
